import React from 'react'
import { useSlate } from 'slate-react'
import { cx } from '@emotion/css'

import Icon from './TableAddRowIcon'
import { Tooltip } from '../../../../../../../index'

import { insertRowAtEnd } from '../utils/insertRowAtEnd'
//@ts-ignore
import styles from '../style.module.css'

export default (props) => {
  const { tablePath, isSelected, isNodeRTLDirected, colWidths } = props
  let width = '500px';
  if (colWidths) {
    let footerWidth = 0
    Array.from(colWidths).forEach((colWidth: number) => {
      footerWidth = footerWidth + colWidth
    })
    width = `${footerWidth}px`
  }
  const editor = useSlate()
  return (
    <div
      data-testid='table-footer'
      data-type="ignore-deserializer"
      contentEditable={false}
      className={cx(styles['table-row-add'], "scrte-table-row-add")}
      style={{ width: width }}
      onClick={(e) => {
        e.preventDefault()
        insertRowAtEnd(editor, tablePath)
      }}
    >
      <Tooltip content="Add Row" position="bottom">
        <span className={cx(styles['scrte-table-footer-dnd-extra-cell'], isNodeRTLDirected && styles['scrte-table-footer-dnd-extra-cell-rtl'])}>
          <svg data-testid="add-new-row-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7.32814 3.0625C7.32814 2.88128 7.18124 2.73438 7.00002 2.73438C6.8188 2.73438 6.67189 2.88128 6.67189 3.0625V6.49115H3.06177C2.88055 6.49115 2.73364 6.63806 2.73364 6.81928C2.73364 7.00049 2.88055 7.1474 3.06177 7.1474H6.67189V10.9375C6.67189 11.1187 6.8188 11.2656 7.00002 11.2656C7.18124 11.2656 7.32814 11.1187 7.32814 10.9375V7.1474H10.9381C11.1193 7.1474 11.2662 7.00049 11.2662 6.81928C11.2662 6.63806 11.1193 6.49115 10.9381 6.49115H7.32814V3.0625Z" fill="#475161" />
          </svg>
        </span>
      </Tooltip>
      <span className={styles['scrte-table-footer-dnd-extra-cell-end']}></span>
    </div>
  )
}
